import React from "react";
import * as Icons from "lucide-react";

// Inicio: el mismo «+» de la barra inferior; abre Añadir y sigue el flujo normal (análisis, revisión y confirmación).
export const OrganizarFoto = () => (
  <section data-testid="home-organizar" className="bg-white border-2 border-[#C9D8CF] rounded-2xl p-5 shadow-sm space-y-3">
    <h2 className="font-heading font-bold text-xl text-[#1C2421] flex items-center gap-2">
      <Icons.Camera size={24} className="text-[#3A6B56]" /> ¿Tienes algo que organizar?
    </h2>
    <p className="text-base text-[#4A5550]">Haz una foto de una carta, recibo, factura, entrada, reserva o tarjeta de visita. AL DÍA la leerá y te propondrá qué hacer con ella.</p>
    <button data-testid="home-organizar-anadir" aria-label="Añadir" onClick={() => window.dispatchEvent(new Event("aldia-add"))}
      className="w-full flex items-center gap-4 rounded-xl p-2 hover:bg-[#F0F6F2] transition-colors text-left">
      <span className="w-16 h-16 rounded-full bg-[#3A6B56] shadow-lg shadow-[#3A6B56]/30 flex items-center justify-center shrink-0">
        <Icons.PlusCircle size={34} className="text-white" strokeWidth={2} />
      </span>
      <span className="font-heading font-bold text-lg text-[#1C2421]">Solo tienes que pulsar</span>
    </button>
    <p className="text-sm text-[#6E7A74] flex items-center gap-1.5"><Icons.ShieldCheck size={16} className="text-[#3A6B56]" /> Tú confirmas siempre antes de guardar.</p>
  </section>
);
